import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { goToPrivacy, goToPrivacyAction, goToTermAction, Proceed, sendOtpWithUserTypeCheck, textOnChange, toggleCTA, whatsappToggle, } from './actions';
import { RegexConfig } from '../../../configs/config';
import SharedPropsService from '../../../SharedPropsService';
import { areWhatsappUpdatesAllowed } from '../../../configs/uri-config-utils';
import { Platform } from "react-native";
import { getParameters, getPrivacyLinks, getTermsLinks, removeUrlWithoutReload } from "../../../configs/utils";
export const template = (height, termsLink, privacyLink, mobileNumber, isGetUpdatesOnWhatsApp = true, isDisabled = true, isValidNumber = false) => ({
    layout: {
        id: ROUTE.PHONE_NUMBER,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            { id: "phoneNumberScreen", type: WIDGET.PHONE_NUMBER_PAGE }
        ],
    },
    datastore: {
        phoneNumberScreen: {
            height,
            isDisabled,
            isValidNumber,
            privacyAction: {
                routeId: ROUTE.PHONE_NUMBER,
                type: ACTION.PRIVACY_POLICY,
                payload: {}
            },
            termsAction: {
                routeId: ROUTE.PHONE_NUMBER,
                type: ACTION.T_AND_C,
                payload: {}
            },
            action: {
                type: ACTION.PROCEED,
                payload: {},
                routeId: ROUTE.PHONE_NUMBER,
            },
            OnChangeAction: {
                type: ACTION.PHONE_NUMBER,
                payload: { value: "", widgetId: "input" },
                routeId: ROUTE.PHONE_NUMBER,
            },
            state: InputStateToken.DEFAULT,
            caption: { error: "Enter a 10 digit mobile number" },
        },
        tc_text: {
            html: Platform.OS !== "web" ? ` <p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;'>
      By proceeding, I agree to <a style="text-decoration:none"  href = ${termsLink}><span style='color:#1434CB;'>T&Cs </a> and <a style="text-decoration:none" href = ${privacyLink}><span style='color:#1434CB;'>Privacy Policy</a>.
      </p>` : ` <p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;'>
      By proceeding, I agree to <a style="text-decoration:none"  href = ${termsLink}><span style='color:#1434CB;'>T&Cs, </a> <a style="text-decoration:none" href = ${privacyLink}><span style='color:#1434CB;'>Privacy Policy</a> and Authorize to obtain my KYC & bureau information.
      </p>`,
            privacyAction: {
                routeId: ROUTE.PHONE_NUMBER,
                type: ACTION.PRIVACY_POLICY,
                payload: {}
            },
            termsAction: {
                routeId: ROUTE.PHONE_NUMBER,
                type: ACTION.T_AND_C,
                payload: {}
            }
        },
        space0: { size: SizeTypeTokens.XXXL },
        continue: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            label: "Continue",
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            id: 'bt_loginScreen_continue',
            action: {
                type: ACTION.CONTINUE,
                payload: {
                    value: "",
                    widgetId: "continue",
                    isResend: false,
                },
                routeId: ROUTE.PHONE_NUMBER,
            },
        },
        space56: {
            size: Platform.OS === 'web' ? SizeTypeTokens.XXXL : SizeTypeTokens.XXXXXXL
        },
        titleStack: {
            type: StackType.column,
            widgetItems: [
                { id: "space56", type: WIDGET.SPACE },
                { id: "title", type: WIDGET.TEXT },
            ]
        },
        title: {
            label: "Enter your mobile number",
            fontSize: FontSizeTokens.XL,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: "600",
        },
        subTitle: {
            label: "We’ll send an OTP to verify this number",
            color: ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
        },
        input: {
            onlyNumeric: true,
            value: mobileNumber ? `${mobileNumber}` : "",
            isFocus: true,
            regex: RegexConfig.MOBILE,
            type: InputTypeToken.MOBILE,
            state: InputStateToken.FOCUS,
            title: "Mobile number",
            charLimit: 10,
            keyboardType: KeyboardTypeToken.numberPad,
            placeholder: "Enter mobile number",
            id: 'tf_loginScreen_phoneNumber',
            action: {
                type: ACTION.PHONE_NUMBER,
                payload: { value: "", widgetId: "input" },
                routeId: ROUTE.PHONE_NUMBER,
            },
            caption: { error: "Enter a 10 digit mobile number" },
        },
        space1: { size: SizeTypeTokens.SM },
        space2: { size: SizeTypeTokens.Size32 },
        space3: { size: SizeTypeTokens.MD },
        space5: { size: SizeTypeTokens.XXXL },
        space4: { size: SizeTypeTokens.XXXL },
        whatsapp_space: { size: SizeTypeTokens.SM },
        whatsappStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.flexStart,
            widgetItems: [
                { id: "radio", type: WIDGET.RADIO, padding: {
                        top: 6,
                        bottom: 6,
                        left: 6,
                        right: 6
                    } },
                { id: "whatsapp_space", type: WIDGET.SPACE },
                {
                    id: "tc_text",
                    type: WIDGET.TERMS_TEXT,
                },
            ],
        },
        radio: {
            id: 'rb_loginScreen_check',
            color: ColorTokens.Primary_100,
            isChecked: true,
            size: IconSizeTokens.MD,
            actionChecked: {
                type: ACTION.WHATSAPP_CHECK,
                payload: { value: true, widgetId: "radio" },
                routeId: ROUTE.PHONE_NUMBER,
            },
            actionUnChecked: {
                type: ACTION.WHATSAPP_UNCHECK,
                payload: { value: false, widgetId: "radio" },
                routeId: ROUTE.PHONE_NUMBER,
            },
        },
        whatsapp: {
            label: "Get updates on WhatsApp",
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.XXS,
            color: ColorTokens.Grey_Night,
        },
    },
});
export const phoneNumberMF = {
    onLoad: async ({ instrumentTrack, addUseProperty, navigate, getHeight }, { mobileNumber, disabled, validNumber }) => {
        instrumentTrack("SIGNUP_PAGE_VIEWED");
        const isGetUpdatesOnWhatsApp = areWhatsappUpdatesAllowed(await SharedPropsService.getURL());
        console.warn("Mobile number received is ", mobileNumber);
        const newUrl = Platform.OS === 'web' ? window.location.href : '';
        const newParams = Platform.OS === 'web' ? getParameters(newUrl) : {};
        const platform = newParams?.platform;
        if (platform) {
            addUseProperty('x-appPlatform', platform);
        }
        if (newParams.leads) {
            const leadId = newParams.leadId;
            if (leadId) {
                removeUrlWithoutReload("leadId");
            }
            removeUrlWithoutReload("leads");
            await navigate(ROUTE.OTP_VERIFY, {
                phone_number: "+91" + mobileNumber,
                leadId: leadId || null
            });
        }
        const termsLink = getTermsLinks();
        const privacyLink = getPrivacyLinks();
        return Promise.resolve(template(getHeight(), termsLink, privacyLink, mobileNumber, isGetUpdatesOnWhatsApp, disabled, validNumber));
    },
    actions: {
        [ACTION.CONTINUE]: sendOtpWithUserTypeCheck,
        [ACTION.PHONE_NUMBER]: textOnChange,
        [ACTION.WHATSAPP_CHECK]: whatsappToggle,
        [ACTION.WHATSAPP_UNCHECK]: whatsappToggle,
        [ACTION.ENABLE_CONTINUE]: toggleCTA,
        [ACTION.DISABLE_CONTINUE]: toggleCTA,
        [ACTION.PRIVACY]: goToPrivacy,
        [ACTION.PRIVACY_POLICY]: goToPrivacyAction,
        [ACTION.T_AND_C]: goToTermAction,
        [ACTION.PROCEED]: Proceed,
    },
};
